import { format } from "date-fns"

import getSeason from "@/utils/getSeason"

import type { DataLayerEvent, DetailsRecord } from "../types"
import calculateDaysToArrival from "./calculateDaysToArrival"

export const createBaseEvent = (
  event: string,
  language: string,
  resortName: string,
  startDate: Date | null,
  departureDate: Date | null,
  details: DetailsRecord
): DataLayerEvent => {
  const { ecommerce, ...restDetails } = details
  return {
    ...(ecommerce !== undefined ? { ecommerce } : {}),
    event,
    Language: language,
    Resort: resortName,
    ArrivalDate: startDate ? format(startDate, "yyyy-MM-dd") : "",
    DepartureDate: departureDate ? format(departureDate, "yyyy-MM-dd") : "",
    DaysToArrival: calculateDaysToArrival(startDate).toString(),
    Season: startDate ? getSeason(startDate) : "",
    ...restDetails,
  } as DataLayerEvent
}
